import React from 'react';
import { connect } from 'react-redux';
import { withRouter, } from "react-router-dom";
import styles from './css/thankyou.module.css';
import Timeline from './timeline';
function thankyou(props) {
    return (React.createElement("div", null,
        React.createElement(Timeline, { currentPage: 6 }),
        React.createElement("div", { className: styles.contentHolder },
            React.createElement("div", { className: styles.row },
                React.createElement("h3", null, "Thank you for your installation request!")),
            React.createElement("div", { className: styles.row },
                React.createElement("h5", null,
                    "Your Service Event number is: ",
                    props.serviceEventId)),
            React.createElement("div", { className: styles.row },
                React.createElement("p", null, "An InstallerNet coordinator will be contacting you with confirmation")),
            React.createElement("div", { className: styles.row },
                React.createElement("span", null,
                    "Return to ",
                    React.createElement("a", { href: "https://weatherflow.com" }, "Weatherflow"),
                    " site")))));
}
function mapStateToProps(state) {
    return {
        serviceEventId: state.app.lastServiceEventId
    };
}
export default withRouter(connect(mapStateToProps)(thankyou));
